import React, { memo } from "react";
import { CardBody } from "react-bootstrap";

import type { IApplication } from "../../../hooks/reactQueryHooks/useApplications";
import { ApplicationTable } from "./ApplicationsTable";

interface IProps {
  data: IApplication[];
  isFetching: boolean;
  isLoading: boolean;
}

const ApplicationsPage: React.FC<IProps> = memo(
  ({ data, isLoading, isFetching }) => {
    return (
      <div className="card">
        <CardBody>
          <ApplicationTable isLoading={isLoading || isFetching} data={data} />
        </CardBody>
      </div>
    );
  },
);

export { ApplicationsPage };
